import { render, staticRenderFns } from "./DateOfBirthPage.vue?vue&type=template&id=8b8a622c&scoped=true&"
import script from "./DateOfBirthPage.vue?vue&type=script&lang=js&"
export * from "./DateOfBirthPage.vue?vue&type=script&lang=js&"
import style0 from "./DateOfBirthPage.vue?vue&type=style&index=0&id=8b8a622c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8a622c",
  null
  
)

export default component.exports